import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, Chip, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import {
  formatDecimalInput,
  normalizeDecimalInput,
} from "../utils/saleProductForm.utils";

const TYPE_LABELS = {
  ingredient: "Insumo",
  preparedProduct: "Elaborado",
  recipe: "Receta",
};

export default function SaleProductComponentRow({
  component,
  reviewAffected = false,
  error,
  disabled,
  onChange,
  onBlur,
  onRemove,
}) {
  return (
    <Box
      data-review-affected={reviewAffected ? "true" : undefined}
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "minmax(0, 1fr) 38px", sm: "minmax(150px, 1fr) 150px 38px" },
        gap: 1,
        alignItems: "center",
        px: reviewAffected ? 1 : 0,
        py: 0.8,
        borderRadius: reviewAffected ? "10px" : 0,
        border: reviewAffected
          ? "1px solid rgba(195, 60, 60, 0.35)"
          : "1px solid transparent",
        borderBottomColor: reviewAffected
          ? "rgba(195, 60, 60, 0.35)"
          : "rgba(64,64,94,.12)",
        bgcolor: reviewAffected ? "rgba(195, 60, 60, 0.06)" : "transparent",
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography noWrap title={component.name} sx={{ fontSize: 12.5, fontWeight: 800 }}>
          {component.name}
        </Typography>
        <Box sx={{ mt: 0.3, display: "flex", gap: 0.5, alignItems: "center" }}>
          <Chip
            label={TYPE_LABELS[component.kind]}
            size="small"
            sx={{ height: 19, fontSize: 9.5, fontWeight: 800 }}
          />
          {reviewAffected ? (
            <Chip
              label="Revisar"
              size="small"
              color="error"
              sx={{ height: 19, fontSize: 9.5, fontWeight: 800 }}
            />
          ) : null}
        </Box>
      </Box>
      <TextField
        value={component.quantity}
        onChange={(event) => onChange?.({ quantity: normalizeDecimalInput(event.target.value) })}
        onBlur={() => {
          onChange?.({ quantity: formatDecimalInput(component.quantity) });
          onBlur?.();
        }}
        disabled={disabled}
        error={Boolean(error)}
        helperText={error}
        size="small"
        inputProps={{
          inputMode: "decimal",
          maxLength: 14,
          "aria-label": `Cantidad de ${component.name}`,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Typography sx={{ fontSize: 10.5, fontWeight: 800 }}>
                {component.unitLabel}
              </Typography>
            </InputAdornment>
          ),
        }}
        sx={{
          gridColumn: { xs: "1 / -1", sm: "auto" },
          gridRow: { xs: 2, sm: "auto" },
          "& .MuiOutlinedInput-root": { height: 35, borderRadius: "10px", bgcolor: "white" },
          "& .MuiFormHelperText-root": { mx: 0, fontSize: 9.5 },
        }}
      />
      <IconButton
        type="button"
        size="small"
        disabled={disabled}
        onClick={onRemove}
        aria-label={`Quitar ${component.name}`}
        sx={{ color: "error.main" }}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
